import { paymentCfg } from "../../components/AppProvider";
import { postApiToJson } from "../network/Network";
import { setBKTransaction } from "../network/padoPost";
import { _O } from "../utils";

const REACT_APP_EASYPAY = paymentCfg.url;

export const payment = (
  userinfo,
  cfg,
  phonecfg,
  setMoveUrl,
  setPageIdx,
  params
) => {
  const url = REACT_APP_EASYPAY;
  // const rtnUrl = cfg.webUrl + 'payment/?userToken=';

  postApiToJson(url, params).then(res => {
    if (res.resCd === "0000") {
      postSetBKTransaction(
        userinfo,
        cfg,
        phonecfg,
        1,
        res,
        setMoveUrl,
        setPageIdx
      );
    } else {
      alert("에러:::" + res.resMsg);
    }
  });
};

export const postSetBKTransaction = (
  userinfo,
  cfg,
  phonecfg,
  cardSeqNo,
  params,
  setMoveUrl,
  setPageIdx
) => {
  setBKTransaction(
    userinfo,
    cfg,
    phonecfg,
    cardSeqNo,
    params.resCd,
    params.resMsg,
    params.authPageUrl,
    params.authPageUrl.substring(
      params.authPageUrl.indexOf("=") + 1,
      params.authPageUrl.length
    )
  ).then(res => {
    if (res.rsltMsg === "SUCC") {
      setMoveUrl(params.authPageUrl);

      if (setPageIdx && setPageIdx != "") {
        setPageIdx(9);
      }
    } else {
      alert("결제연동 실패");
    }
  });
};
